import { render, staticRenderFns } from "./BindingHouse.vue?vue&type=template&id=5e173a6a&"
import script from "./BindingHouse.vue?vue&type=script&lang=js&"
export * from "./BindingHouse.vue?vue&type=script&lang=js&"
import style0 from "./BindingHouse.vue?vue&type=style&index=0&id=5e173a6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports